<style>
html {
  font-size: 50px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
  overflow: hidden;
}

/* body * {
  box-sizing: border-box;
  flex-shrink: 0;
} */

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-start {
  justify-content: flex-start;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}
</style>

<template>
  <div class="flex-col page">
    <div class="authorize_main fs16 flex1">
      <div class="info c333">
        <div class="pl16 pr16 pt20">
          <div class="flex ai_e">
            <img class="logo mr8" :src="apiProduct.imgUrl" />
            <div class="fw500">{{ apiProduct.name }}</div>
            <div class="fs10 ml12">通过率高 | 线上审核 | 当天放款</div>
          </div>
          <div class="line mt8"></div>
          <div class="flex mt16 fs10">
            <div class="flex1">
              <div class="title_bg center fw500">平均额度（元)</div>
            </div>
            <div class="flex1">
              <div class="title_bg center fw500">近 7 天通过率</div>
            </div>
          </div>
          <div class="flex ai_e mt16">
            <div class="fs36 fw500 flex1 ff_d amount">200,000</div>
            <div class="c_o flex1"><span class="fs24 ff_d">90</span>%</div>
          </div>
        </div>
        <div class="mt14 info_des fs10 pr">
          此助贷咨询服务由第三方合作机构提供，第三方信贷专员需要电话审核及门店办理，请您注意接听电话。
        </div>
      </div>

      <div class="porotocol_popup fs14 p16 bgfff mt18 authorize_proto">
        <div class="center">
          <van-tabs
            v-model="tabActiveRef"
            class="scroll_x"
            :before-change="beforeChange"
          >
            <van-tab class="fw500" title="《个人信息共享授权协议》"></van-tab>
            <van-tab
              class="fw500"
              :title="`《${e.name}》`"
              v-for="(e, i) in apiProduct.grantUrls"
              :key="i"
            ></van-tab>
          </van-tabs>
        </div>
        <div class="line"></div>
        <div class="scroll_bg pr mt16">
          <div class="scrollbar">
            <span
              class="font_4 text_11"
              v-html="apiProduct.content"
              v-if="!urlRef"
            >
            </span>
            <iframe
              class="porotocol_popup_iframe"
              :src="urlRef"
              v-else
            ></iframe>
          </div>
          <div class="bg_line"></div>
          <div class="bg_line1"></div>
        </div>
      </div>

      <!-- <Proto :list="apiRef.grantUrls" class="authorize_proto bgfff mt18" v-if="apiRef.grantUrls?.length" /> -->
    </div>

    <div class="flex-col justify-start bgfff p16">
      <div
        class="button1 center"
        v-prevent-reclick
        @click="handleAgreeProtocol"
      >
        <span class="text_13">同意协议激活额度</span>
      </div>
    </div>

    <!-- <div class="flex-col justify-start flex-auto group_2">
      <div class="flex-col justify-start relative section">
        <div class="flex-col section_2 space-y-8 pos_2">
          <div class="flex-col group_3">
            <div class="flex-row items-start">
              <img
                class="shrink-0 image_3"
                src="../../assets/images/icon_result_header.png"
              />
              <div class="flex-col items-center flex-auto group_4">
                <span class="text_2">为您精选以下机构和产品</span>
                <span class="text_3">专业贷款咨询服务，在线秒接单</span>
              </div>
              <div
                class="flex-col justify-start items-center shrink-0 image-wrapper"
              ></div>
            </div>
            <div class="flex-col relative section_3">
              <div class="flex-row justify-between items-center group_5">
                <span class="font_1">产品指定方案</span>
                <div class="flex-col">
                  <div class="flex-row items-start space-x-6">
                    <span class="font_1">已选1个产品</span>
                  </div>
                  <span class="self-start font_2 text_4"
                    >（共可选1个产品）</span
                  >
                </div>
              </div>
              <div class="flex-row group_6">
                <img
                  class="image_6"
                  :src="require('../../../public/fangxin_logo.png')"
                />
                <span class="font_3 text_5">{{ this.productName }}</span>
                <span class="font_2 text_company">{{ this.companyName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-col section_4 space-y-24 pos_4">
        <div class="group_7">
          <span class="font_3 text_6">特别提醒：</span>
          <span class="font_3 text_7"
            >{{
              this.apiProduct.name
            }}会根据您的综合资信状况，为您推荐以下贷款机构产品:</span
          >
          <span class="font_3 text_8">{{ this.productName }}</span>
          <span class="font_3 text_9">，具体请阅读并同意相关协议</span>
          <span class="font_3 text_10" v-on:click="handleProtocol(12)"
            >《个人信用查询授权书》</span
          >
          <span
            class="font_3 text_10"
            v-show="this.apiProduct.partnerGrantLicence !== undefined"
            v-on:click="pushAuthProtocol"
            >《个人信息授权书》</span
          >
          <span
            class="font_3 text_10"
            v-show="this.apiProduct.partnerPrivacyLicence !== undefined"
            v-on:click="pushPrivacyProtocol"
            >《隐私政策》</span
          >
          <span
            v-for="(item, index) in apiProduct.grantUrls"
            :key="index"
            class="font_3 text_10"
            v-on:click="handleProtocol(item.grantUrl)"
            >《{{ item.name }}》</span
          >
        </div>
        <div class="flex-col space-y-8">
          <div class="flex-col justify-start items-start relative group_8">
            <span
              class="font_4 text_11"
              v-html="apiProduct.content"
              v-show="!isShowExternalProtocol"
            >
            </span>
            <iframe
              :src="this.apiProduct.partnerGrantLicence"
              v-show="isShowExternalProtocol"
              width="100%"
              height="600"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
      <div class="flex-col justify-start section_8 pos_7">
        <div
          class="flex-col justify-start items-center button"
          v-prevent-reclick
          @click="handleAgreeProtocol"
        >
          <span class="text_13">同意协议，激活额度</span>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import * as API_Common from "@/api/common.js";
import { toRedirectUrlAndSaveRecordNoDebounce } from "@/api/common.js";
import "@/assets/styles/base_new.scss";
import { Tab, Tabs } from "vant";

export default {
  name: "matchingResultsNwd",
  data() {
    return {
      channel: this.$route.query.source,
      model: sessionStorage.getItem("model"),
      isConnectRate: false, //是否保证门店接通率 true:惠利花流程 flase:匹配大联登流程
      rpChecked: false,
      productName: "",
      companyName: "",
      isRequesting: false, // 用于标记是否正在请求
      apiProduct: {
        imgUrl: "",
        thirdPartyId: "",
        productId: "",
        companyName: "",
        name: "",
        userId: "",
        content: "",
        pushRecordId: "",
        grantValue: "", //4腰部机构授权 6手动授权
        redirectUrl: "",
        orderId: "",
        partnerPrivacyLicence: undefined, //隐私协议
        partnerGrantLicence: undefined, //个人授信协议
        level: "",
        agentCode: "",
        grantApiLists: "",
        grantUrls: [], // 协议列表示例: [{ name: '协议一', grantUrl: 'https://...' }, ...]
      },
      recommendProduct: {},
      unionLogin: {
        productId: 0,
        url: "",
      },
      HYHList: [],
      isShowExternalProtocol: false,
      tabActiveRef: 0,
      urlRef: "",
    };
  },
  mounted() {
    window.sessionStorage.removeItem("showPopUpView");
    this.getAPIProduct();
    this.handleUserResidenceTime();
  },
  methods: {
    beforeChange(i) {
      if (i) {
        const item = this.apiProduct.grantUrls[i - 1];
        this.urlRef = item.grantUrl;
      } else {
        this.urlRef = "";
      }
      return true;
    },
    //API机构和授权书
    getAPIProduct() {
      API_Common.getUser2WhereApi().then((res) => {
        if (res.code === 200) {
          this.apiProduct = {
            ...this.apiProduct,
            ...(res.data || {}),
            // grantUrls: [
            //   { name: "机构相关协议", grantUrl: "https://www.baidu.com/" },
            //   { name: "机构", grantUrl: "https://www.baidu.com/" },
            //   { name: "机构相协议", grantUrl: "https://www.baidu.com/" },
            // ],
          };
          //以机构id判断是否为快易贷
          if (
            this.apiProduct.thirdPartyId >= 420 &&
            this.apiProduct.thirdPartyId <= 424 &&
            this.apiProduct.partnerGrantLicence !== undefined
          ) {
            this.isShowExternalProtocol = true;
          }

          if (this.apiProduct.level === 2 && this.apiProduct.grantApiLists) {
            //惠逸花
            API_Common.delayModel9SUpdate(
              this.channel,
              0,
              0,
              8,
              this.apiProduct.thirdPartyId
            );
            this.HYHList = JSON.parse(this.apiProduct.grantApiLists);
            let model = this.HYHList[0];
            this.productName = model.productName
              ? model.productName
              : model.name;
            this.companyName = model.companyName;
          } else {
            //头部机构 橙易通
            this.productName = this.apiProduct.name;
            this.companyName = this.apiProduct.companyName;
          }
        }
      });
    },
    //同意协议
    handleAgreeProtocol() {
      if (this.apiProduct.grantValue === 6 && this.apiProduct.level === 1) {
        API_Common.middleDataEventTracking(
          this.apiProduct.pushRecordId,
          this.apiProduct.thirdPartyId
        );
      }
      //保门店接通率策略 原有流程 落地页判断是否有惠利花
      if (this.isConnectRate) {
        //头部结构跳转到api结果界面
        if (this.apiProduct.level === 1) {
          this.$router.replace({
            name: "auditResult_nwd",
            query: { source: this.$route.query.source },
          });
        } else {
          //处理腰部机构 不考虑尾部
          this.handleSameIndustry();
        }
      } else {
        //忽略门店接通率策略 大联登流程
        if (this.apiProduct.level === 1) {
          //头部api 跳转大联登
          this.getChannleProductList();
        } else {
          //处理腰部机构 不考虑尾部
          this.handleSameIndustry();
        }
      }
    },
    //同业机构处理
    handleSameIndustry() {
      if (
        this.apiProduct.level === 2 &&
        this.apiProduct.grantApiLists.length > 0
      ) {
        //腰部机构 调用接口 4月29日修改 腰部机构不考虑接通率策略 腰部产品判断是否匹配到大联登 匹配大联登->大联登流程 没匹配->原有流程
        this.requestSameIndustryData();
      } else {
        this.getChannleProductList();
      }
    },
    //同业接口请求
    requestSameIndustryData() {
      // 如果正在请求中，直接返回，不执行任何操作
      if (this.isRequesting) {
        return;
      }
      // 标记正在请求中
      this.isRequesting = true;
      // 准备API请求的数据
      const array = this.HYHList.map((model) => ({
        productId: model.productId,
        institutionName: model.institutionName,
      }));
      const data = {
        orderId: this.apiProduct.orderId,
        products: array,
      };
      // 调用API
      API_Common.getHYHProductData(data, this.apiProduct.agentCode)
        .then((res) => {
          //不考虑成功失败情况
        })
        .finally(() => {
          API_Common.delayModel9SUpdate(
            this.channel,
            0,
            0,
            7,
            this.apiProduct.thirdPartyId
          );
          this.getChannleProductList();
          // 3秒后解除重复点击限制
          setTimeout(() => {
            this.isRequesting = false;
          }, 3000); // 3秒钟后允许再次点击
        });
    },

    // 根据渠道code读取产品推荐信息 将权重最大的进行显示
    getChannleProductList() {
      API_Common.getProductsInResultPage(this.channel).then((res) => {
        if (res.code === 200) {
          let dataArr = res.data;
          if (dataArr.length > 0) {
            this.recommendProduct = dataArr[0];
            this.handleProductResult();
          } else {
            this.pushCpaResult();
          }
        } else {
          this.pushCpaResult();
        }
      });
    },
    //根据返回不同的产品类型 调用不同接口
    handleProductResult() {
      let userId = window.localStorage.getItem("userId");
      let redirectUrl = this.recommendProduct.linkUrl; // 默认跳转 URL
      let isWeCom = this.recommendProduct.isWeCom;
      const buriedData = {
        channel: this.channel,
        userId: userId,
        productId: this.recommendProduct.id,
        showPage: 4,
      };
      var that = this;
      if (this.recommendProduct.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          that.recommendProduct.id,
          that.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            await that.pushCpaResult();
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch(async (error) => {
            await that.pushCpaResult();
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.recommendProduct.isToRegister === 3) {
        API_Common.getUnionLogin4ClickV3(
          that.recommendProduct.id,
          that.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            await that.pushCpaResult();
            that.unionLogin = res.data;
          })
          .catch(async (error) => {
            await that.pushCpaResult();
          })
          .finally(() => {
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                channel: that.channel,
                productId: that.recommendProduct.id,
                showPage: 4,
                userId: userId,
              },
              isWeCom
            );
          });
      } else {
        this.pushCpaResult();
      }
    },
    //跳转落地页
    pushCpaResult() {
      // let routeName = this.getPushRouterName();
      this.$router.replace({
        name: "auditResult_nwd",
        query: { source: this.channel },
      });
    },
    //获取跳转路由
    getPushRouterName() {
      const source = this.$route.query.source;
      const validSources = ["paipai", "paipai1", "paipai2", "paipai3"];
      const sourceRouteMap = {
        paipai4: "applyResults",
        huanbei2: "userAudit1",
        huanbei1: "userAudit1",
      };
      let routeName = sourceRouteMap[source];
      if (
        !routeName &&
        (validSources.includes(source) ||
          this.model === "modelDj" ||
          this.model === "modelhb")
      ) {
        routeName = "userAudit";
      }
      routeName = routeName || "userAudit";
      return routeName;
    },
    //跳转机构授权协议
    pushAuthProtocol() {
      window.location.href = this.apiProduct.partnerGrantLicence;
    },
    //跳转机构隐私协议
    pushPrivacyProtocol() {
      window.location.href = this.apiProduct.partnerPrivacyLicence;
    },
    // 跳转机构返回协议
    handleProtocol(url) {
      window.location.href = url;
    },
    //埋点 监听停留时间
    handleUserResidenceTime() {
      API_Common.delayModel8SUpdate(this.channel, 0, 9, 9);
    },
  },
};
</script>
<style scoped>
@import "../../css/model8PopView.css";
</style>
<style scoped lang="scss">
body {
  box-sizing: border-box;
  position: relative;
  overflow-y: hidden;
  height: 100vh;
}

.page {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  position: relative;
}

.header {
  padding-bottom: 0.24rem;
  background-color: #ffffff;
  height: 1.77rem;
}

.space-y-12 > *:not(:first-child) {
  margin-top: 0.24rem;
}

.image {
  width: 7.5rem;
  height: 0.88rem;
}

.group {
  padding: 0.08rem 0.32rem 0;
}

.image_2 {
  width: 0.4rem;
  height: 0.4rem;
}

.pos {
  position: absolute;
  left: 0.32rem;
  top: 50%;
  transform: translateY(-50%);
}

.font_1 {
  font-size: 0.32rem;
  font-family: PingFangSC-Medium;
  color: #000000;
}

.text {
  font-size: 0.34rem;
  line-height: 0.31rem;
}

.group_2 {
  /*overflow-y: hidden;*/
  /*overflow-x: hidden;*/
  width: 100%;
  height: 100vh;
  position: fixed;
  background-image: url("../../assets/images/model8/bg.png");
  border-radius: 0.02rem;
  background-size: 100%, 100%;
  background-repeat: no-repeat;
}

.section {
  padding-top: 7.48rem;
  border-radius: 0.02rem;
}

.section_6 {
  background-image: linear-gradient(180deg, #f9f9f900 0%, #f5f8ff 100%);
  border-radius: 0.02rem;
  height: 5.4rem;
}

.section_2 {
  padding-top: 0.3rem;

  border-radius: 0.02rem;
}

.space-y-88 > *:not(:first-child) {
  margin-top: 1.77rem;
}

.pos_2 {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

.group_3 {
  padding-left: 0.24rem;
  height: 3.66rem;
}

.image_3 {
  width: 1.08rem;
  height: 1.14rem;
}

.group_4 {
  margin-left: 0.08rem;
  margin-top: 0.24rem;
}

.space-y-10 > *:not(:first-child) {
  margin-top: -0.08rem;
}

.text_2 {
  color: #000000;
  font-size: 0.32rem;
  font-family: SourceHanSansSC;
  margin-top: -0.05rem;
}

.text_3 {
  color: #000000;
  font-size: 0.24rem;
  font-family: SourceHanSansSC;
  margin-top: -0.01rem;
}

.image-wrapper {
  margin: 0.16rem -1.2rem 0 0.32rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 3.44rem;
  height: 3.2rem;
}

.image_4 {
  filter: drop-shadow(0.28rem 0.18rem 0.09rem #1c7bf5);
  width: 3.44rem;
  height: 3.2rem;
}

.section_3 {
  margin: -2.2rem 0.3rem 0 0.06rem;
  padding: 0.32rem 0.16rem 0;
  background-color: #ffffff;
  border-radius: 0.16rem;
}

.group_5 {
  padding: 0rem 0.12rem 0rem 0.2rem;
  border-bottom: solid 1px #eeeeee;
}

.space-x-6 > *:not(:first-child) {
  margin-left: 0.12rem;
}

.image_5 {
  margin-top: 0.12rem;
  width: 0.26rem;
  height: 0.26rem;
}

.font_2 {
  font-size: 0.22rem;
  font-family: PingFangSC;
  color: #999999;
}

.text_4 {
  margin-bottom: 0.2rem;
}

.group_6 {
  padding: 0.3rem 1rem 0.3rem 1rem;
}

.font_3 {
  font-size: 0.22rem;
  font-family: PingFangSC;
  line-height: 0.4rem;
  color: #000000;
}

.text_5 {
  font-size: 0.24rem;
  line-height: 0.22rem;
  margin-top: 0.12rem;
  margin-left: 0.2rem;
  color: #000000;
}

.text_company {
  margin-top: 0.12rem;
  margin-left: 0.2rem;
  display: block;
  line-height: 0.22rem;
}

.image_6 {
  width: 0.48rem;
  height: 0.48rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-left: 0.3rem;
}

.pos_3 {
  position: absolute;
  left: 1.22rem;
  bottom: 0.32rem;
}

.section_5 {
  background-image: linear-gradient(180deg, #f9f9f900 0%, #f5f8ff 100%);
  height: 4.13rem;
}

.section_7 {
  background-color: #f5f8ff;
  height: 3rem;
}

.pos_6 {
  position: absolute;
  left: 0;
  right: 0;
  top: 9.86rem;
}

.section_4 {
  padding: 0.26rem 0.12rem 0rem 0.2rem;
  background-color: #ffffff;
  border-radius: 0.16rem;
  font-size: 0px;
  position: relative;
}

.space-y-24 > *:not(:first-child) {
  margin-top: 0.48rem;
}

.pos_4 {
  position: fixed;
  left: 0.3rem;
  right: 0.3rem;
  top: 4.3rem;
  bottom: 1.4rem;
  overflow-y: hidden;
}

.group_7 {
  margin-left: 0.04rem;
}

.text_6 {
  color: #ff7a1a;
  text-align: justify;
}

.text_7 {
  text-align: justify;
}

.text_8 {
  color: #2a7eff;
  text-align: justify;
  text-decoration: underline;
}

.text_9 {
  text-align: justify;
}

.text_10 {
  color: #437eff;
  text-align: justify;
}

.space-y-8 > *:not(:first-child) {
  margin-top: 0.16rem;
}

.group_8 {
  margin-right: 0.2rem;
  width: 6.5rem;
  height: 55vh;
  overflow: scroll;
}

.font_4 {
  font-size: 0.26rem;
  font-family: PingFangSC;
  line-height: 0.4rem;
  color: #000000;
}

.text_11 {
  text-align: justify;
  text-indent: 0px;
}

.text_12 {
  text-align: justify;
  text-indent: 2.34rem;
}

.pos_5 {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.section_8 {
  background-color: #ffffff;
  box-shadow: 0px 0.04rem 0.08rem #00000080;
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.section_8 {
  background-color: #ffffff;
  box-shadow: 0px 0.04rem 0.08rem #00000080;
  margin-top: 0rem;
  margin-bottom: 0rem;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 10px;
}

.button1 {
  background: linear-gradient(90deg, #f87464 0%, #ef4034 100%);
  border-radius: 1.08rem;
  height: 1.08rem;
}

.text_13 {
  color: #ffffff;
  font-size: 0.32rem;
  font-family: PingFangSC;
  font-weight: 700;
}

.self-center {
  align-self: center;
}

.authorize_main {
  padding: 0.4rem 0.32rem 0.6rem;
  .info {
    background: url("./img/bg2.png") no-repeat right top/2.44rem,
      linear-gradient(180deg, #ffe6db 0, #fff 80%);
    box-shadow: 0 0.08rem 0.12rem 0 rgba(251, 200, 200, 0.07);
    border-radius: 0.16rem;
    overflow: hidden;
    border: 0.02rem solid #fff;
    .logo {
      width: 0.32rem;
      height: 0.32rem;
    }
    .line {
      height: 0.02rem;
      background: linear-gradient(
        90deg,
        transparent 0,
        #fbe5dd 50%,
        transparent 100%
      );
    }
    .title_bg {
      width: 1.52rem;
      height: 0.32rem;
      background: linear-gradient(90deg, #fae4cd 0%, #f4bd9e 100%);
      border-radius: 0.04rem;
      color: #7d3e14;
    }
    .info_des {
      padding: 0.12rem 0.3rem 0.12rem 0.6rem;
      line-height: 0.32rem;
      background: linear-gradient(180deg, #fff3ed 0, transparent 100%);
      color: #bd8763;
      &::after {
        content: "!";
        position: absolute;
        left: 0.3rem;
        top: 0.2rem;
        width: 0.2rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        color: #fff;
        font-size: 0.18rem;
        background: #ddbca8;
        border-radius: 100%;
      }
    }
  }
  .authorize_proto {
    border-radius: 0.16rem;
    overflow: hidden;
  }
  .amount {
    line-height: 0.6rem;
  }
}

::v-deep .van-tabs__wrap {
  margin-top: 0.05rem;
  height: auto;
  overflow: visible;
  .van-tab {
    color: #666;
    padding: 0 0 0.16rem 0;
    font-weight: 400;
    font-size: 0.24rem;
    margin-left: 0.2rem;
    flex: 0 0 auto;
    &--active {
      color: #000;
      font-weight: 700;
    }
    &:first-child {
      margin-left: 0;
    }
  }
  .van-tabs__nav--line {
    padding: 0;
    background: transparent;
  }
  .van-tabs__line {
    width: 1.2rem;
    height: 0.04rem;
    background: #ef4034;
    border-radius: 0.04rem;
    bottom: 0;
  }
}
.porotocol_popup {
  .line {
    position: relative;
    left: -0.32rem;
    top: -0.02rem;
    width: calc(100% + 0.64rem);
    height: 0.02rem;
    background: #ffe8e2;
  }
  .scroll_x {
    z-index: 1;
  }
  .scrollbar {
    max-height: 6rem;
    overflow: auto;
  }
  .scroll_bg {
    padding: 0.12rem 0.08rem;
    outline-offset: 0.06rem;
    outline: 0.02rem solid #f6ddd6;
    border: 0.02rem solid #f6ddd6;
    background: linear-gradient(0, #f6ddd6 0, #f6ddd6 100%) no-repeat 0 0/0.12rem
        0.12rem,
      linear-gradient(0, #f6ddd6 0, #f6ddd6 100%) no-repeat right 0/0.12rem
        0.12rem,
      linear-gradient(0, #f6ddd6 0, #f6ddd6 100%) no-repeat 0 bottom/.12rem
        0.12rem,
      linear-gradient(0, #f6ddd6 0, #f6ddd6 100%) no-repeat right bottom/.12rem
        0.12rem;
  }
  .bg_line,
  .bg_line1 {
    &:after,
    &::before {
      content: "";
      position: absolute;
      width: 0.26rem;
      height: 0.28rem;
      left: -0.1rem;
      top: -0.1rem;
      border-top: 0.04rem solid #fff;
      border-right: 0.02rem solid #f6ddd6;
      border-bottom: 0.02rem solid #f6ddd6;
      border-left: 0.04rem solid #fff;
    }
    &::before {
      left: auto;
      right: -0.1rem;
      border-right: 0.04rem solid #fff;
      border-left: 0.02rem solid #f6ddd6;
    }
  }
  .bg_line1 {
    &:after,
    &::before {
      left: -0.1rem;
      top: auto;
      bottom: -0.1rem;
      border-top: 0.02rem solid #f6ddd6;
      border-right: 0.02rem solid #f6ddd6;
      border-bottom: 0.04rem solid #fff;
      border-left: 0.04rem solid #fff;
    }
    &::before {
      left: auto;
      right: -0.1rem;
      border-right: 0.04rem solid #fff;
      border-left: 0.02rem solid #f6ddd6;
    }
  }

  &_iframe {
    width: 100%;
    height: 6rem;
  }
}
</style>
